import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import './EmptyComp.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from '../../Routers/history';

class EmptyComp extends Component {

    UNSAFE_componentWillMount() {
        let currentBotId = localStorage.getItem('bot_id');
        if (currentBotId) {
            history.replace(`/${currentBotId}/chatbot`);
        }
    }

    selectFirstBot = (botList) => {
        if (botList && botList.length) {
            history.replace(`/${botList[0].id}`);
        }
        return (
            <div className='dropdown-menu'></div>
        );
    }

    render() {
        return (
            <div className='tab-pane fade active in show'>
                <div className='tab-section-wrapper bot-selection-tab'>
                    <div className='tab-header-wrapper' style={{minHeight: '32px'}}>
                        <h3 className='tab-header'> No Bot available to Customise </h3>
                    </div>
                    <div className='bot-selection-hint-text'>Please add a bot to continue with BotForge</div>
                    {this.selectFirstBot(this.props.availableBotList)}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : []
    };
};



const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmptyComp));